'use strict';

class Titlebar extends Widget {
  _element: any;
  _dialog: any;
  _closeButton: any;

  constructor(element: any) {
    super(element);
    this._dialog = this.parent('dialog');
    this._element.on('pointerdown', this._onMouseDown.bind(this));

    if (this._element.hasClass('close')) {
      this._closeButton = ui.button('.close');
      this._closeButton.text('X');
      this._closeButton.on('clicked', this._dialog.hide.bind(this._dialog));
      this._closeButton._element.insertAfter(this._element);
    }
  }

  dragEnabled(enabled?: any) {
    if (enabled === undefined) {
      return this._element.hasClass('drag');
    } else if (enabled !== this.dragEnabled()) {
      this._element.toggleClass('drag');
    }
  }

  _onMouseDown(downEvent: any) {
    const self = this;
    const offset = this._dialog._element.offset();
    ui.bringToTop(this._dialog);

    if (!this.dragEnabled()) {
      return;
    }

    this._element.css('cursor', 'move');

    function mouseMove(moveEvent: any) {
      self._dialog._element.offset({
        left: moveEvent.pageX - downEvent.pageX + offset.left,
        top: moveEvent.pageY - downEvent.pageY + offset.top
      });
    }

    function mouseUp() {
      self._element.css('cursor', 'default');
      $(document).off('pointermove', mouseMove);
      $(document).off('pointerup pointercancel', mouseUp);
    }

    $(document).on('pointermove', mouseMove);
    $(document).on('pointerup pointercancel', mouseUp);
  }

  static Create() {
    return $('<div class="titlebar" />');
  }
}

ui.Titlebar = Titlebar;
ui.titlebar = ui.widgetConstructor('titlebar', ui.Titlebar);
